module.exports = __webpack_public_path__ + "static/media/wave2.f51026aa.jpg";